import axios from 'axios'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { getHeaderJWT, URL } from '../../../store/path'
import { setAlertModalState } from '../../common/data/actions'
import { fetchedUploadedFiles } from './actions'
import { extractErrorMessage } from './errorMsg'


function* fetchUploadedFiles() {
    yield takeLatest('FETCH_UPLOADED_FILES', requestUploadedFiles)
}

function* requestUploadedFiles(action) {
    const { response, error } = yield call(requestUploadedFilesAPI, action.payload)
    if (response) {
        const data = response.data
        if (data && data.type === 'error') {
            yield put(fetchedUploadedFiles([]))
            yield put(setAlertModalState({
                isOpen: true,
                type: 'error',
                size: 'mini',
                title: 'Fetch Error',
                msg: extractErrorMessage(data, 'Failed to fetch uploaded files.'),
            }))
            return
        }
        const list = Array.isArray(data) ? data : (data && Array.isArray(data.data) ? data.data : [])
        yield put(fetchedUploadedFiles(list))
    } else {
        yield put(fetchedUploadedFiles([]))
        const msg = extractErrorMessage(error?.response?.data, error?.message || 'Failed to fetch uploaded files.')
        yield put(setAlertModalState({
            isOpen: true,
            type: 'error',
            size: 'mini',
            title: 'Fetch Error',
            msg,
        }))
    }
}

function requestUploadedFilesAPI(data) {
    return axios.post(URL + '/upload/master/uploaded-files', data, getHeaderJWT(), { crossDomain: true })
        .then(response => ({ response }))
        .catch(error => ({ error }))
}


export default function* uploaderSaga() {
    yield all([
        fetchUploadedFiles(),
    ])
}
